import { baseApi, TAG } from '../../app/api/baseApi'
import { CONNECTION_LIST_TAG } from '../connections/connectionsApi'
import { connectorImage } from './connectorImages'
const asArray = (data) => (Array.isArray(data) ? data : [])
const NO_LOCAL_IMAGE = () => null
const listWithImages = async (baseQuery, listUrl, imageUrl, localImage = NO_LOCAL_IMAGE) => {
    const list = await baseQuery(listUrl)
    if (list.error) {
        return { error: list.error }
    }
    const items = asArray(list.data)
    const images = await Promise.all(items.map((item) => {
        const local = localImage(item)
        return local ? { data: local } : baseQuery(imageUrl(item.id))
    }))
    return {
        data: items.map((item, index) => ({ ...item, image: images[index].error ? null : images[index].data }))
    }
}
export const marketplaceApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getMarketplaceEndpoints: builder.query({
            queryFn: (arg, api, extraOptions, baseQuery) => listWithImages(
                baseQuery,
                '/MarketPlace/endpoints',
                (id) => `/MarketPlace/endpoints/${id}/image`,
                (endpoint) => connectorImage(endpoint.shortName)
            )
        }),
        getEndpointIntegrations: builder.query({
        queryFn: (endpointId, api, extraOptions, baseQuery) => listWithImages(
                baseQuery,
                `/MarketPlace/endpoints/${endpointId}/connectors`,
                (id) => `/MarketPlace/connectors/${id}/image`
            )
        }),
        getEgeIntegrations: builder.query({
            queryFn: (arg, api, extraOptions, baseQuery) => listWithImages(baseQuery, '/MarketPlace/endpoints/ege/connectors', (id) => `/MarketPlace/connectors/${id}/image`)
        }),
        getConnectorVersions: builder.query({
            query: (connectorId) => `/MarketPlace/connectors/${connectorId}/endpoint-versions`,
            transformResponse: asArray
        }),
        getConnectorFeatures: builder.query({
            query: ({ connectorId, sourceVersion, targetVersion }) => ({
                url: `/MarketPlace/connectors/${connectorId}/features`,
                method: 'POST',
                body: { id: connectorId, sourceVersion: `${sourceVersion}`, targetVersion: `${targetVersion}` }
            }),
            transformResponse: asArray
        }),
        getLatestConnectorVersionId: builder.query({
            query: (connectorId) => `/MarketPlace/connectors/${connectorId}/version`
        }),
        getConnectorQuestions: builder.query({
            query: (versionId) => ({
                url: `/MarketPlace/connectors/${versionId}/questions`,
                method: 'POST',
                body: { id: `${versionId}` }
            }),
            transformResponse: asArray
        }),
        getTrialConnectors: builder.query({
            query: () => '/Connector/TrialConnectors'
        }),
        createSubscription: builder.mutation({
            query: (body) => ({ url: '/Subscription', method: 'POST', body }),
            // The first connection also creates the client, which makes the user its Owner.
            invalidatesTags: (result, error) => (error ? [] : [CONNECTION_LIST_TAG, TAG.DASHBOARD, TAG.CLIENT_PERMISSION])
        }),
        createTrialSubscription: builder.mutation({
            query: (body) => ({ url: '/Subscription/TrialSubscription', method: 'POST', body })
        })
    })
})

export const {
    useGetMarketplaceEndpointsQuery,
    useGetEndpointIntegrationsQuery,
    useGetEgeIntegrationsQuery,
    useGetConnectorVersionsQuery,
    useGetConnectorFeaturesQuery,
    useLazyGetConnectorFeaturesQuery,
    useLazyGetLatestConnectorVersionIdQuery,
    useGetConnectorQuestionsQuery,
    useLazyGetConnectorQuestionsQuery,
    useGetTrialConnectorsQuery,
    useCreateSubscriptionMutation,
    useCreateTrialSubscriptionMutation
} = marketplaceApi
